import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Route element registered at /voucher in the unauthenticated branch of the router.
// Captures the full hash (including ?userId=...&rewardId=...) into redirectAfterLogin
// itself, deterministically, before navigating — see voucher-dynamic-variable-plan.md's
// 2026-08-28 revision for why this can't be a declarative <Navigate> or left to App.js's
// separate mount effect (child-effects-before-parent-effects ordering risk).
export default function VoucherLoginRedirect() {
    const navigate = useNavigate();
    const location = useLocation();

    // Read the router's location, not window.location: this guard can remount after
    // trackUserLogout has already pushed /login, and the live hash would then be "/login".
    useEffect(() => {
        localStorage.setItem("redirectAfterLogin", location.pathname + location.search);
        navigate("/login", { replace: true });
    }, []);

    return null;
}
